import React, { Component } from 'react';
import Button from 'Components/Button';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import OnboardingTooltip from 'Components/OnboardingTooltip/OnboardingTooltip';
// import { updateUserOnBoard } from '../../actions/userActions';
import OutsideClickHandler from 'Components/OutsideClickHandler/OutsideClickHandler';

import './OnboardingHierarchy.scss';

export class OnboardingHierarchy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTopicTobeIntroducedToUser: false,
      onBoardObject: null,
      isDepedentPresent: false,
    };
    this.attachBindings();
  }

  attachBindings() {
    this.filterTopicTobeIntroduced = this.filterTopicTobeIntroduced.bind(this);
    this.closeTooltip = this.closeTooltip.bind(this);
  }

  filterTopicTobeIntroduced(onBoardTopics, topicKey) {
    return onBoardTopics.find((iterator) => {
      if (iterator.topicKey === topicKey) {
        return true;
      }
    });
  }

  componentDidMount() {
    const onBoardObject = this.filterTopicTobeIntroduced(this.props.onBoardTopics, this.props.topicKey);


    const dependentBoardObject = this.filterTopicTobeIntroduced(this.props.onBoardTopics, this.props.depedentTopicKey);
    let isDepedentPresent = true;
    if (dependentBoardObject !== undefined) {
      isDepedentPresent = dependentBoardObject.hasUserIntroduced;
    }
    const isTopicTobeIntroducedToUser = onBoardObject && !onBoardObject.hasUserIntroduced;

    this.setState({
      showOnboardOverlay: this.props.showOnboardOverlay,
      isTopicTobeIntroducedToUser,
      isDepedentPresent,
      onBoardObject,
    });
  }

  componentDidUpdate(nextProps) {
    const onBoardObject = this.filterTopicTobeIntroduced(nextProps.onBoardTopics, this.props.topicKey);
    if (onBoardObject && !onBoardObject.hasUserIntroduced && !this.state.isDepedentPresent) {
      const dependentBoardObject = this.filterTopicTobeIntroduced(this.props.onBoardTopics, this.props.depedentTopicKey);
      if (dependentBoardObject !== undefined && dependentBoardObject.hasUserIntroduced) {
        this.setState({
          isDepedentPresent: true,
        });
      }
    }
  }

  closeTooltip() {
    this.setState({
      isTopicTobeIntroducedToUser: false,
    }, () => {
      this.props.updateOnBoard(this.props.topicKey);
    });
  }

  render() {
    const {
      topicKey,
      extraClass,
      showOnboardOverlay,
      showButton,
      showCloseIcon,
      showTip,
    } = this.props;

    const { isTopicTobeIntroducedToUser, isDepedentPresent } = this.state;

    return (
      <div>
        {isTopicTobeIntroducedToUser && showOnboardOverlay
          && <div className="overlay-onboarding" />}
        {isTopicTobeIntroducedToUser && isDepedentPresent && showTip && <OutsideClickHandler
          onClickOutside={this.closeTooltip}
        >
          {<OnboardingTooltip
            extraClass={extraClass}
            tooltipText={this.state.onBoardObject.topicText}
            closeTooltip={this.closeTooltip}
            showButton={showButton}
            showCloseIcon={showCloseIcon}
          />
          }
        </OutsideClickHandler>}
      </div>
    );
  }
}

OnboardingHierarchy.propTypes = {
  topicKey: PropTypes.string,
  showOnboardOverlay: PropTypes.bool,
  showButton: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  showTip: PropTypes.bool,
  extraClass: PropTypes.string,
  onBoardTopics: PropTypes.array,
};

OnboardingHierarchy.defaultProps = {
  topicKey: '',
  extraClass: '',
  showOnboardOverlay: false,
  showButton: false,
  showCloseIcon: true,
  showTip: true,
  onBoardTopics: [],
};

const mapStateToProps = (state) => ({
  onBoardTopics: [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    // updateOnBoard: (topicKey) => dispatch(updateUserOnBoard(topicKey)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OnboardingHierarchy));
